import React from 'react';
import './Approach.css';
import RevealOnScroll from './RevealOnScroll';
import { 
  ClipboardText, 
  PaintBrushBroad, 
  CodeBlock, 
  PlugsConnected, 
  BugBeetle, 
  RocketLaunch,
  ShieldPlus,
  ChartLineUp
} from '@phosphor-icons/react';

const steps = [
  {
    icon: <ClipboardText size={32} weight="light" color="#0ea5e9"/>,
    title: "Requirement Analysis",
    desc: "Deep dive into your business objectives, user needs, and project scope."
  },
  {
    icon: <PaintBrushBroad size={32} weight="light" color="#0ea5e9"/>,
    title: "UI/UX-Driven Design",
    desc: "Craft visually appealing, intuitive interfaces with responsive design."
  },
  {
    icon: <CodeBlock size={32} weight="light" color="#0ea5e9"/>,
    title: "Custom Architecture",
    desc: "Build scalable web architectures using modern frameworks and design patterns."
  },
  {
    icon: <ShieldPlus size={32} weight="light" color="#0ea5e9"/>,
    title: "Frontend & Backend Dev",
    desc: "Develop full-stack apps using React, Angular, Vue, Node.js, Django & more."
  },
  {
    icon: <PlugsConnected size={32} weight="light" color="#0ea5e9"/>,
    title: "API Integration",
    desc: "Seamless integration with third-party APIs, CRMs, and data services."
  },
  {
    icon: <BugBeetle size={32} weight="light" color="#0ea5e9"/>,
    title: "Testing & QA Automation",
    desc: "Ensure quality through functional, performance, and security testing."
  },
  {
    icon: <RocketLaunch size={32} weight="light" color="#0ea5e9"/>,
    title: "Deployment & Integration",
    desc: "Ensure quality through functional, performance, and security testing."
  },
  {
    icon: <ChartLineUp size={32} weight="light" color="#0ea5e9"/>,
    title: "Maintenance & Scaling",
    desc: "Ongoing support, monitoring, and infrastructure optimization post-launch."
  }
];

const Approach = () => {
  return (
    <section className="approach-section">
      <div className="approach-container">
        <RevealOnScroll>
          <h2 className="approach-heading">Our Development Approach</h2>
        </RevealOnScroll>
        <div className="approach-grid">
          {steps.map((step, index) => (
            <RevealOnScroll key={index} delay={index * 100}>
              <div className="approach-card">
                <div className="icon-wrapper">{step.icon}</div>
                <h3 className="card-title">{step.title}</h3>
                <p className="card-desc">{step.desc}</p>
              </div>
            </RevealOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Approach;
